import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const TrackingPage = () => {
  const { orderId, productId } = useParams();
  const [product, setProduct] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [colorMap, setColorMap] = useState({});
  const [sizeMap, setSizeMap] = useState({});

  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    if (user_id && orderId && productId) {
      fetchOrderDetails();
      fetchColorList();
      fetchSizeList();
    } else {
      setLoading(false);
    }
  }, [orderId, productId]);

  const fetchOrderDetails = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_new_order",
        { user_id }
      );

      if (res.data.status === "true" || res.data.status === true) {
        const orders = res.data.data || [];
        
        // Find the specific order
        const order = orders.find(o => o.order_id == orderId);
        
        if (order && order.items) {
          // Find the specific product in this order
          const productItem = order.items.find(item => item.product_id == productId);
          
          if (productItem) {
            setProduct(productItem);
            setOrderInfo(order);
          }
        }
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchColorList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_mst_prod_color"
      );

      if (res.data?.status) {
        const map = {};
        res.data.colors.forEach((item) => {
          map[item.color_id] = item.color_name;
        });
        setColorMap(map);
      }
    } catch (err) {
      console.error("Color Fetch Error:", err);
    }
  };

  const fetchSizeList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_mst_prod_size"
      );

      if (res.data?.status) {
        const map = {};
        res.data.row.forEach((item) => {
          map[item.size_id] = item.size_label;
        });
        setSizeMap(map);
      }
    } catch (err) {
      console.error("Size Fetch Error:", err);
    }
  };

  if (!user_id) {
    return (
      <div className="container py-5 text-center">
        <h5>Please login to view order details</h5>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h5>Loading order details...</h5>
      </div>
    );
  }

  if (!product || !orderInfo) {
    return (
      <div className="container py-5 text-center">
        <h5>Order not found</h5>
      </div>
    );
  }

  return (
    <div className="container-fluid myntra-order-container py-4">
      <div className="container tracking-page">
        <div className="row justify-content-center">

          {/* Order Summary */}
          <div className="col-md-10 mb-4">
            <div className="card shadow-sm">
              <div className="card-body d-flex flex-wrap align-items-center">
                <div className="order-img me-3">
                  <img
                    src={
                      product.multi_image
                        ? `https://cyberathon.com/multivendor/${product.multi_image}`
                        : "https://via.placeholder.com/100"
                    }
                    className="img-fluid rounded"
                    style={{ width: "100px" }}
                    alt={product.product_name}
                  />
                </div>
                <div>
                  <h6 className="fw-bold mb-1">{product.product_name}</h6>
                  <p className="text-muted mb-1">
                    {product.color && `Color: ${colorMap[product.color] || product.color}`}
                    {product.color && product.size && ' | '}
                    {product.size && `Size: ${sizeMap[product.size] || product.size}`}
                  </p>
                  <p className="text-muted mb-1">Qty: {product.qty} | Price: ₹{product.subtotal || (product.price * product.qty)}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tracking Timeline */}
          <div className="col-md-10">
            <div className="tracking-list">

              {/* Step 1 */}
              <div className="tracking-item active">
                <div className="tracking-icon">
                  <i className="fa-solid fa-circle-check text-success"></i>
                </div>
                <div className="tracking-content">
                  <h6>Order Placed</h6>
                  <small>{orderInfo.created_at || orderInfo.order_date}</small>
                </div>
              </div>

              {/* Step 2 */}
              <div className="tracking-item active">
                <div className="tracking-icon">
                  <i className="fa-solid fa-truck text-primary"></i>
                </div>
                <div className="tracking-content">
                  <h6>Shipped</h6>
                  <small>10 Aug 2025, 03:00 PM</small>
                </div>
              </div>

              {/* Step 3 */}
              <div className="tracking-item active">
                <div className="tracking-icon">
                  <i className="fa-solid fa-location-dot text-warning"></i>
                </div>
                <div className="tracking-content">
                  <h6>Out for Delivery</h6>
                  <small>12 Aug 2025, 06:00 PM</small>
                </div>
              </div>

              {/* Step 4 */}
              <div className="tracking-item pending">
                <div className="tracking-icon">
                  <i className="fa-regular fa-circle text-muted"></i>
                </div>
                <div className="tracking-content">
                  <h6>Delivered</h6>
                  <small>Expected: 12 Aug 2025, 09:00 PM</small>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TrackingPage;